import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { sendDigitaleHeldenMail } from '@adornis/digitale-helden-shared/features/mailing/server/mailer.js';
import { Recipient } from '@adornis/mails/db/recipients.js';
import { Message } from '@adornis/mails/server/communication.js';
import { Lead } from '../../../db/Lead.js';
import { pressepaketTemplate } from '../../../features/mailing/server/templates/pressepaket-template.js';

export const sendMediaPackageMail = registerMutation({
  type: () => String,
  operationName: 'sendMediaPackageMail',
  resolve: (concern: string, lead: Lead, companyName?: string) => {
    return async () => {
      await sendDigitaleHeldenMail({
        message: async (webversionLink: string) =>
          await Message.compose(
            await pressepaketTemplate({
              concern,
              companyName,
              webmailLink: webversionLink,
              email: lead.email,
              firstName: lead.firstName,
              lastName: lead.lastName,
            }),
          ),
        recipients: new Recipient(['presse@digitale-helden.de']),
      });
    };
  },
  params: [
    { name: 'concern', type: () => String },
    { name: 'lead', type: () => Lead },
    { name: 'companyName', type: () => String },
  ],
});
